import Utility from "../Base/Utility";
import Constants from "../Base/Constants";
import NodeUtility from "./NodeUtility";
import Attribute from "./Attribute";
import IDObject from "../Base/IDObject";
import Ensure from "../Base/Ensure";
/**
 * Base class for any components
 * component must be attach to node before any operation.
 */
export default class Component extends IDObject {
    constructor() {
        super(...arguments);
        /**
         * Whether this component was created by nodeDeclaration
         * @type {boolean}
         */
        this.isDefaultComponent = false;
        this.disposed = false;
        /**
         * Flag that this component is activated or not.
         * @type {boolean}
         */
        this._enabled = true;
        this._awaked = false;
        this._handlers = [];
        this._additionalAttributesNames = [];
        this._initializedInfo = null;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(val) {
        if (this._enabled === val) {
            return;
        }
        this._enabled = val;
        this._handlers.forEach((handler) => {
            handler(this);
        });
    }
    /**
     * The dictionary which is shared in entire tree.
     * @return {NSDictionary<any>} [description]
     */
    get companion() {
        return this.node.companion;
    }
    /**
     * Tree interface for the tree this node is attached.
     * @return {GomlInterface} [description]
     */
    get tree() {
        return this.node.tree;
    }
    get isActive() {
        return this.enabled && !!this.node && this.node.isActive;
    }
    /**
     * Set value of attribute
     * @param {string} name  [description]
     * @param {any}    value [description]
     */
    setAttribute(name, value) {
        if (typeof name === "string" && Ensure.checkFQNString(name)) {
            name = this.name.fqn + "." + name; // TODO: test
        }
        const attr = this.attributes.get(name);
        if (attr) {
            attr.Value = value;
        }
    }
    getAttribute(name) {
        if (typeof name === "string" && Ensure.checkFQNString(name)) {
            name = this.name.fqn + "." + name; // TODO: test
        }
        const attr = this.getAttributeRaw(name);
        if (attr) {
            return attr.Value;
        }
        else {
            throw new Error(`attribute ${name} is not defined in ${this.name.fqn}`);
        }
    }
    getAttributeRaw(name) {
        if (typeof name === "string" && Ensure.checkFQNString(name)) {
            name = this.name.fqn + "." + name; // TODO: test
        }
        return this.attributes.get(name);
    }
    addEnabledObserver(observer) {
        this._handlers.push(observer);
    }
    removeEnabledObserver(observer) {
        return Utility.remove(this._handlers, observer);
    }
    resolveDefaultAttributes(nodeAttributes) {
        const nodeAttr = nodeAttributes || {};
        if (this.isDefaultComponent) {
            this.attributes.forEach(attr => attr.resolveDefaultValue(nodeAttr));
        }
        else {
            const attrs = NodeUtility.getAttributes(this.element);
            for (let key in attrs) {
                if (key === Constants.x_gr_id) {
                    continue;
                }
            }
            this.attributes.forEach(attr => attr.resolveDefaultValue(attrs));
        }
    }
    dispose() {
        this.node.removeComponent(this);
    }
    awake() {
        if (this._awaked) {
            return false;
        }
        this._awaked = true;
        let method = this["$$awake"];
        if (typeof method === "function") {
            method();
        }
        return true;
    }
    initialized(info) {
        if (this._initializedInfo === info) {
            return;
        }
        this._initializedInfo = info;
        let method = this["$$initialized"];
        if (typeof method === "function") {
            method(info);
        }
    }
    __addAtribute(name, attribute) {
        console.warn(`${this.name.fqn} is using '__addAtribute()'.\nthis method is deprecated because typo.\nplease use '__addAttribute() instead of.'`);
        this.__addAttribute(name, attribute);
    }
    /**
     * Add additional attribute to this component.
     * @param {string}                name      [description]
     * @param {IAttributeDeclaration} attribute [description]
     */
    __addAttribute(name, attribute) {
        if (!attribute) {
            throw new Error("can not add attribute null or undefined.");
        }
        const attr = Attribute.generateAttributeForComponent(name, attribute, this);
        this.node.addAttribute(attr);
        if (this.isDefaultComponent) {
            attr.resolveDefaultValue(NodeUtility.getAttributes(this.node.element));
        }
        else {
            const attrs = NodeUtility.getAttributes(this.element);
            attr.resolveDefaultValue(attrs);
        }
        this._additionalAttributesNames.push(attr.name);
        return attr;
    }
    __removeAttributes(name) {
        if (name) {
            const index = this._additionalAttributesNames.findIndex(id => id.name === name);
            if (index < 0) {
                throw new Error("can not remove attributes :" + name);
            }
            const attrId = this._additionalAttributesNames[index];
            this.node.removeAttribute(this.attributes.get(attrId));
            this.attributes.delete(attrId);
            this._additionalAttributesNames.splice(index, 1);
        }
        else {
            const arr = this._additionalAttributesNames.concat();
            arr.forEach(id => {
                this.__removeAttributes(id.name);
            });
        }
    }
    __bindAttributes() {
        this.attributes.forEach(attr => {
            const name = attr.name.name;
            attr.boundTo(name);
        });
    }
}



// WEBPACK FOOTER //
// ./src/Node/Component.ts